import { useDrop } from 'react-dnd'
import styles from './Card.module.scss'
import ImageDropCursor from 'src/assets/icons/drop_cursor.svg?react'


type Props = {
  accept: string
  onDrop: (item: any) => void
  isAusCourse?: boolean
  isNewMovable?: boolean
}

function DropBox(props: Props) {
    const { accept, onDrop } = props

    const [{ isOver, canDrop }, drop] = useDrop({
        accept,
        drop: onDrop,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    })

    const isActive = isOver && canDrop
    let dropCardStyle = styles.dropGradeCard
    let label = "Drag and Drop Content"
    if (isActive) {
        dropCardStyle = styles.dropGradeCard
    } else if (canDrop) {
        dropCardStyle = styles.dropUnitsCard

    }

    return (
        <div ref={drop} className={`${dropCardStyle} ${canDrop ? styles.canDropbackground : ''}`}>
            <div>
                <ImageDropCursor className={styles.dropImage}/>
                <p className={styles.labelPadding}>{label}</p>
            </div>
        </div>
    )
}

export default DropBox
